import React from 'react'

import { FormBuilder, Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import Button from 'components/Button'
import FormContainer from 'components/FormContainer'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { style } from 'theme'

import { TestIDs } from '../../test/utils/testIds'
import enhance from './enhance'
import { Props } from './types'

export const StyledHeroHeader = styled.h1`
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 40px;
  text-align: center;
  max-width: 400px;
  
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0 0 30px;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    max-width: 340px;
  }
`

export const StyledHeroSubtext = styled.div`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  margin: 0 auto 20px;
  max-width: 340px;

  p {
    margin: 0;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`

export const LaterSuitabilityQuestions: React.SFC<Props> = ({
  errors,
  handleNextPressed,
  headerText,
  interceptHandleChange,
  interceptSelectHandleChange,
  isSubmitting,
  rows,
  showNextButton,
  subheaderText,
  values,
}) => (
  <>
    <Nav back={true} />
    <Layout header={headerText} text={subheaderText}>
      <StyledHeroHeader data-testid="later_suitability_title">{headerText}</StyledHeroHeader>
      <StyledHeroSubtext data-testid="later_suitability_helper_text">
        {subheaderText}
      </StyledHeroSubtext>
      <FormContainer laterSuitability>
        {rows && (
          <FormBuilder
            errors={errors}
            handleChange={interceptHandleChange}
            handleSelectChange={interceptSelectHandleChange}
            rows={rows}
            values={values}
          />
        )}
      </FormContainer>
      <Separator addMargin />

      {showNextButton && (
        <>
          <Separator addMargin />
          <Button
            onPress={handleNextPressed}
            data-testid={TestIDs.LATER_SUITABILITY_QUESTIONS.NEXT_CTA}
            disabled={isSubmitting}
          >
            {isSubmitting ? <Spinner height={20} width={20} white={true} /> : 'Next'}
          </Button>
        </>
      )}
    </Layout>
  </>
)

export default enhance(LaterSuitabilityQuestions)
